import React from 'react';
import { ChevronLeft20Regular } from '@fluentui/react-icons';
import { Button } from '../../Button/Button';
import { useTranslation } from 'react-i18next';
import './NavTopbar.css';

export interface NavTopbarProps {
  onBackBtnClick: () => void;
  headline?: string;
}

export const NavTopbar: React.FC<NavTopbarProps> = ({
  onBackBtnClick,
  headline = '',
}) => {
  const { t } = useTranslation();

  return (
    <div className="navTopbar flex items-center">
      <div className="backBtnWrapper">
        <Button
          primaryTransparent
          icon={<ChevronLeft20Regular />}
          onClick={onBackBtnClick}
        >
          {t('back', { defaultValue: 'Zurück' })}
        </Button>
      </div>
      {headline !== '' && (
        <div className="headline flex w-full items-center justify-center">{headline}</div>
      )}
    </div>
  );
};
